import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BrowserStorageHelper } from '@core/helpers';
import { UserGroupService } from '@core/services/user-group.service';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisTooltipComponent } from '@shared/components';
import { Subscription } from 'rxjs';
import { TrapFocusDirective } from '../../../shared/directives/trap-focus.directive';
import { MenuGroupComponent } from '../menu-group/menu-group.component';

@Component({
    selector: 'app-menu-profile[closePopover][isSwitchGroupDisplayed][switchGroupDisplayChange]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
    standalone: true,
    imports: [TrapFocusDirective, NgTemplateOutlet, TranslateModule, MenuGroupComponent, EllipsisTooltipComponent],
})
export class MenuProfileComponent implements OnDestroy {
    @Input() isSwitchGroupDisplayed: boolean = false;
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();
    @Output() switchGroupDisplayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    readonly accountSettingsUrl = environment.accountSettingsUrl;
    readonly quickorderSettingsUrl = environment.quickorderSettingsUrl;
    readonly billingSettingsUrl = environment.billingSettingsUrl;
    readonly messageSettingsUrl = environment.messageSettingsUrl;

    private readonly subscriptions = new Subscription();

    groupName: string = '';

    constructor(
        private auth0: AuthService,
        private userGroupService: UserGroupService
    ) {
        this.subscriptions.add(
            this.userGroupService.currentGroup$.subscribe(userGroup => {
                this.groupName = userGroup?.name ?? '';
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    close(): void {
        this.switchGroupDisplayChange.emit(false);
        this.closePopover.emit();
    }

    toggleMenuGroupOverlay(value: boolean): void {
        this.switchGroupDisplayChange.emit(value);

        // necessary for accessibility
        if (value) {
            setTimeout(() => {
                document.getElementById('app-menu-group-header')?.focus();
            }, 100);
        }
        if (!value) {
            setTimeout(() => {
                document.getElementById('user-group')?.focus();
            }, 100);
        }
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;
        BrowserStorageHelper.killSession();

        await this.auth0.logout({
            openUrl(_url) {
                window.location.replace(url);
            },
        });
    }
}
